import { Component, Input } from '@angular/core';
import { customData, dataType } from 'src/app/models/callContext.model';
import { TooltipDirective } from '../tooltip.directive';
import { WebViewInteropService } from 'src/app/service/web-view-interop.service';
import { CopyButtonComponent } from '../copy-button/copy-button.component';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-data-table',
    imports: [TooltipDirective, CopyButtonComponent, CommonModule],
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.css']
})
export class DataTableComponent {
  @Input() entry!: customData[];
  @Input() sliceStart: number = 0;
  type = dataType;

  constructor(private webViewInterop: WebViewInteropService){};

   get allValuesText(): string {
    return this.entry
      .map(e => `${e.title}: ${e.value}`)
      .join('\n');
  }

  openLink(url: string)
  {
    if(url.startsWith("http"))
    {
      this.webViewInterop.openLink(url);
    }
    else
    {
      this.webViewInterop.openLink("http://" + url);
    }

  }

  openPhone(url: string)
  {
    this.webViewInterop.openLink("callto:"+ url.replace(" ",""));
  }

}
